import { onlyNumeric } from '@origin-digital/normalize';
import { Field } from 'formik';
import React from 'react';

import { alphaNumericTransform } from '../../../../utils/transforms';
import PostcodeField from '../PostcodeField';
import FormRow from '../../Layout/FormRow';
import TextField from '../TextField';
import SelectField from '../SelectField';
import { ManualAddressProps } from './ManualAddress.types';

const ManualAddress: React.StatelessComponent<ManualAddressProps> = ({
  ...props
}: ManualAddressProps): JSX.Element | null => {
  const {
    formData,
    validating,
    graphQuery,
    productType,
    changeHandler,
    isDisqualified,
    addressCheckHandler,
    isInitialValid,
    hasManualAddress
  } = props;

  if (!hasManualAddress) {
    return null;
  }

  return (
    <FormRow content={formData.content.address} byline={formData.content.address.byline}>
      <Field
        name={formData.fields.unit.name}
        isInitialValid={isInitialValid}
        component={TextField}
        label={formData.fields.unit.label}
        changeHandler={changeHandler}
        maxLength={150}
      />
      <Field
        name={formData.fields.streetNumber.name}
        component={TextField}
        isInitialValid={isInitialValid}
        label={formData.fields.streetNumber.label}
        transform={alphaNumericTransform}
        changeHandler={changeHandler}
        maxLength={10}
      />
      <Field
        name={formData.fields.streetName.name}
        component={TextField}
        isInitialValid={isInitialValid}
        label={formData.fields.streetName.label}
        changeHandler={changeHandler}
        maxLength={150}
      />
      <Field
        name={formData.fields.streetType.name}
        component={TextField}
        isInitialValid={isInitialValid}
        label={formData.fields.streetType.label}
        changeHandler={changeHandler}
        maxLength={150}
      />
      <Field
        name={formData.fields.city.name}
        isInitialValid={isInitialValid}
        component={TextField}
        label={formData.fields.city.label}
        changeHandler={changeHandler}
        maxLength={150}
      />
      <Field
        name={formData.fields.state.name}
        component={SelectField}
        isInitialValid={isInitialValid}
        label={formData.fields.state.label}
        changeHandler={changeHandler}
        options={formData.fields.state.options}
      />
      <Field
        name={formData.fields.postcode.name}
        component={PostcodeField}
        label={formData.fields.postcode.label}
        productType={productType}
        isDisqualified={isDisqualified}
        parseGraphResult={(data: any) => data.serviceable}
        graphQuery={graphQuery}
        validating={validating}
        changeHandler={changeHandler}
        addressCheckHandler={addressCheckHandler}
        transform={onlyNumeric}
        maxLength={4}
      />
    </FormRow>
  );
};

export { ManualAddress as default };
